import { ActionType } from "typesafe-actions";

import * as actions from "./actions";

export type FAQAction = ActionType<typeof actions>;

export enum FAQActionTypes {
  CATEGORIES_FETCH_REQUEST = "@FAQ/CATEGORIES_FETCH_REQUEST",
  CATEGORIES_FETCH_SUCCESS = "@FAQ/CATEGORIES_FETCH_SUCCESS",
  CATEGORIES_FETCH_ERROR = "@FAQ/CATEGORIES_FETCH_ERROR",

  ARTICLE_FETCH_REQUEST = "@FAQ/ARTICLE_FETCH_REQUEST",
  ARTICLE_FETCH_SUCCESS = "@FAQ/ARTICLE_FETCH_SUCCESS",
  ARTICLE_FETCH_ERROR = "@FAQ/ARTICLE_FETCH_ERROR",
}

export interface ShortFAQArticle {
  id: number;
  slug: string;
  title: string;
  createdAt: string;
}

export interface FAQCategory {
  id: number;
  title: string;
  createdAt: string;
  articles: ShortFAQArticle[];
}

export interface FAQArticle extends ShortFAQArticle {
  content: string;
}

export interface FAQState {
  categories: FAQCategory[];
  isCategoriesLoading: boolean;

  article?: FAQArticle;
  isArticleLoading: boolean;
}
